import { FC, useEffect } from 'react'
import { useMount } from 'react-use'
import useCourseThemes from '@hooks/useCourseThemes'
import { createInitFilter } from '@utils/filters'
import { AccordionBodyProps } from '@organisms/Accordion'
import Onboarding from '@templates/Onboarding'
import OnboardingCodes from '@enums/OnboardingCodes'
import Theme from './Theme'
import { ONBOARDING_STEPS, ONBOARDING_TITLE } from './onboarding'

type Props = {
  id: number
  themeNumber: number
  courseIri: string
  educationId: string | number
  isClientCourse?: boolean
} & AccordionBodyProps

const Body: FC<Props> = ({
  id,
  onChangeSize,
  toggleLoading,
  themeNumber,
  courseIri,
  educationId,
  isClientCourse,
}) => {
  const { data, refetch } = useCourseThemes({
    ...createInitFilter('courseChapter', id),
    ...(+educationId
      ? createInitFilter(
          'forEmployeeEducation',
          '/api/employee_education_destinations/' + educationId
        )
      : {}),
  })
  const { items = [] } = data || {}

  const sortedItems = [...items].sort((a, b) => {
    const sortA = a.sortOrder ?? Number.MAX_SAFE_INTEGER
    const sortB = b.sortOrder ?? Number.MAX_SAFE_INTEGER

    if (sortA === sortB) {
      return a.id - b.id
    }

    return sortA - sortB
  })

  useMount(() => {
    toggleLoading(true)
    refetch()
  })

  useEffect(() => {
    if (data) {
      toggleLoading(false)
      onChangeSize()
    }
  }, [data])

  return (
    <>
      <Onboarding
        firstStepTitle={ONBOARDING_TITLE}
        steps={ONBOARDING_STEPS}
        code={OnboardingCodes.my_education_chapter}
      />
      <div id="chapter">
        {sortedItems.map((item, index) => (
          <Theme
            number={`${themeNumber}.${index + 1}`}
            {...item}
            key={item.id}
            courseIri={courseIri}
            educationId={educationId}
            isClientCourse={isClientCourse}
          />
        ))}
      </div>
    </>
  )
}

export default Body
